import { render } from "./PersonPicker.vue?vue&type=template&id=0ca29a0e&scoped=true&ts=true"
import script from "./PersonPicker.vue?vue&type=script&lang=ts"
export * from "./PersonPicker.vue?vue&type=script&lang=ts"

import "./PersonPicker.vue?vue&type=style&index=0&id=0ca29a0e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca29a0e"]])

export default __exports__